"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ad = void 0;
const class_transformer_1 = require("class-transformer");
const MaxLengthExcludingParameters_1 = require("../decorators/MaxLengthExcludingParameters");
class Ad {
    // text: is just first part of parameeter, length is with } at the end and : between parameter and default value
    static customizedParameters = [{ text: "{=Ad customizers PRICES.Price", length: 31 }];
    adGroupId;
    type = "ExpandedTextAd";
    finalUrls;
    headlinePart1;
    headlinePart2;
    headlinePart3;
    description;
    description2;
    status = "ENABLED";
    approvalStatus = "UNCHECKED";
    trademarkDisapproved = false;
}
exports.Ad = Ad;
__decorate([
    (0, class_transformer_1.Expose)()
    // Google adgroup id
    ,
    __metadata("design:type", Number)
], Ad.prototype, "adGroupId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Ad.prototype, "finalUrls", void 0);
__decorate([
    (0, MaxLengthExcludingParameters_1.MaxLengthExcludingParameters)(Ad.customizedParameters, 30, {}),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "headlinePart1", void 0);
__decorate([
    (0, MaxLengthExcludingParameters_1.MaxLengthExcludingParameters)(Ad.customizedParameters, 30, {}),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "headlinePart2", void 0);
__decorate([
    (0, MaxLengthExcludingParameters_1.MaxLengthExcludingParameters)(Ad.customizedParameters, 30, {}),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "headlinePart3", void 0);
__decorate([
    (0, MaxLengthExcludingParameters_1.MaxLengthExcludingParameters)(Ad.customizedParameters, 90, {}),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "description", void 0);
__decorate([
    (0, MaxLengthExcludingParameters_1.MaxLengthExcludingParameters)(Ad.customizedParameters, 90, {}),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "description2", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "status", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Ad.prototype, "approvalStatus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Ad.prototype, "trademarkDisapproved", void 0);
//# sourceMappingURL=Ad.js.map